module.exports = __webpack_public_path__ + "static/media/tab-4.c3b7e89d.png";